const formatDateToNumber = (date: Date): number => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return parseInt(`${year}${month}${day}`, 10);
};

export const getDateRangeFromMonths = (
  months: number
): {
  startDate: number;
  endDate: number;
} => {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setMonth(startDate.getMonth() - months);

  return {
    startDate: formatDateToNumber(startDate),
    endDate: formatDateToNumber(endDate),
  };
};

export const getDateRangeFromPreviousYear = (): {
  startDate: number;
  endDate: number;
} => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const startDate = new Date(currentYear - 1, 0, 1);
  const endDate = new Date(currentYear - 1, 11, 31);

  return {
    startDate: formatDateToNumber(startDate),
    endDate: formatDateToNumber(endDate),
  };
};
